import React from 'react';
import ModalFrame from '../../dashboard/components/product_item_components/ModalFrame';

export default function CancelOrderConfirmModal({
  isOpen,
  onClose,
  orderLabel,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <ModalFrame title="Отменить заказ" onClose={onClose}>
      <div className="main-page-editBody">
        <div className="main-page-confirmText">
          Вы уверены, что хотите отменить «<b>{orderLabel}</b>»?
        </div>

        <div className="main-page-editActions">
          <button
            type="button"
            className="main-page-editButton main-page-editButtonSecondary"
            onClick={onClose}
          >
            Назад
          </button>
          <button
            type="button"
            className="main-page-editButton main-page-editButtonDanger"
            onClick={onConfirm}
          >
            Отменить
          </button>
        </div>
      </div>
    </ModalFrame>
  );
}
